import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { useAdmin } from '@/hooks/useAdmin';

interface AdminRouteProps {
    children: React.ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
    const { user, loading: authLoading } = useAuth();
    const { isAdmin, loading: adminLoading } = useAdmin();
    const location = useLocation();

    console.log('[AdminRoute] Auth loading:', authLoading, 'Admin loading:', adminLoading);
    console.log('[AdminRoute] User:', user?.email, 'isAdmin:', isAdmin);

    if (authLoading || adminLoading) {
        console.log('[AdminRoute] Still loading, showing spinner');
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div>
            </div>
        );
    }

    if (!user) {
        console.log('[AdminRoute] No user, redirecting to signin');
        return <Navigate to="/signin" state={{ from: location }} replace />;
    }

    if (!isAdmin) {
        console.log('[AdminRoute] User is not admin, redirecting to home');
        return <Navigate to="/" replace />;
    }

    console.log('[AdminRoute] Access granted, showing admin content');
    return <>{children}</>;
} 